/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { capturePasswordResetTokenFromLocation } from './app/core/security/password-reset-token';

capturePasswordResetTokenFromLocation();

// biome-ignore lint/suspicious/noConsole: Standard error catch for Angular
bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
